import React from 'react'

const PageLoading = () => {
  return (
    <div className="page-loading">
      <div className="page-loading__spinner"></div>
    </div>
  )
}
export default PageLoading
